import { useRouteLoaderData } from '@remix-run/react';

import type { loader as communityLoader } from '~/routes/community';

import { type CommunityPurchasableTiers, usePurchasableTiersForIds } from './useCommunityPurchasableTiers';

// Module-level so a missing space keeps the same reference across renders and
// doesn't invalidate the shared tier-filter memo downstream.
const NO_TIER_IDS: string[] = [];

/**
 * Space is resolved by id from `layoutData.spaces`; if it's not found, the
 * intersection resolves to `[]` and `hasPurchasableTier` to false.
 */
export const useSpacePurchasableTiers = ({
  spaceId,
  enabled = true,
}: {
  spaceId?: string | null;
  enabled?: boolean;
}): CommunityPurchasableTiers => {
  const layoutData = useRouteLoaderData<typeof communityLoader>('routes/community');
  const spaceTierIds = spaceId
    ? (layoutData?.spaces?.find((space) => space.id === spaceId)?.premium_tier_ids ?? NO_TIER_IDS)
    : NO_TIER_IDS;

  return usePurchasableTiersForIds(spaceTierIds, enabled);
};
